<template>
  <div>
    <v-form ref="form" lazy-validation>
      <span>Answer all the questions in set {{ getQuestions.set }} </span>
      <div
        class="question"
        v-for="(question, index) in getQuestions.questions"
        :key="question.id"
        :value="question.id"
      >
        <!-- TODO Investigate how to send and receive data from component to parent -->
        <!-- <Question :ques="question" v-model="radios[index]"></Question> -->
        <span>{{ question.question }}</span>
        <v-radio-group name="question.id" v-model="radios[index]">
          <v-radio
            v-for="(choice, i) in question.choices"
            :key="i"
            :label="choice"
            :value="i"
          >
          </v-radio>
        </v-radio-group>
      </div>
      <v-btn color="primary" outline @click="reset">Clear</v-btn>
      <v-btn color="primary" @click="submit">submit</v-btn>
      <!-- <v-btn @click="validate">Validate</v-btn> -->
    </v-form>
    <v-snackbar
      v-model="snackbar.enabled"
      :color="snackbar.color"
      :multi-line="snackbar.mode === 'multi-line'"
      :timeout="snackbar.timeout"
      :vertical="snackbar.mode === 'vertical'"
    >
      {{ snackbar.text }}
      <v-btn dark flat @click="snackbar.enabled = false">
        Close
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import dbStore from "../db/dbStore";

export default {
  created() {
    this.getData();
  },
  data() {
    return {
      radios: [],
      test_success: false,
      tests: [],
      snackbar: {
        enabled: false,
        color: "error",
        timeout: 6000,
        text: "Cannot submit"
      },
      studentProgressModel: {
        Id: "",
        dropped_out: false,
        dropped_out_on: "",
        tests_taken: []
      },
      testsTakenModel: {
        id: "",
        taken_on: "",
        score: 0,
        passed: false
      }
    };
  },
  methods: {
    async getData() {
      dbStore.setCollectionName("tests");
      this.tests = await dbStore.getItems();
    },

    //#TODO make this method simple as its complexity is 14
    async submit() {
      console.log(this.radios);
      //Validate against answer set. For this connect to firebase and
      //get answer sets and validate the answers in memory.
      var num_errors = 0;
      var num_unanswered = 0;
      var msg;
      this.snackbar.text = "";
      if (this.radios.length < this.getQuestions.questions.length) {
        //msg = this.radios.length + " unanswered questions";
        msg =
          "Answer the remaining " +
          (this.getQuestions.questions.length - this.radios.length) +
          " questions";

        this.snackbar.text = msg;
        console.log(msg);
        this.snackbar.enabled = true;
      } else {
        for (var i = 0; i < this.radios.length; i++) {
          if (this.radios[i] === undefined) num_unanswered++;
          if (this.radios[i] !== this.getQuestions.answers[i]) {
            num_errors++;
          }
        }
        if (num_unanswered) {
          if (num_unanswered == 1) {
            msg = "Answer the remaining " + num_unanswered + " question";
          } else {
            msg = "Answer the remaining " + num_unanswered + " questions";
          }
          this.snackbar.text = msg;
          console.log(msg);
          this.snackbar.enabled = true;
        } else {
          var pass =
            ((this.getQuestions.questions.length - num_errors) /
              this.getQuestions.questions.length) *
            100;

          //Update student data with test results
          //console.log(this);
          //console.log(this.studentProgressModel);
          this.studentProgressModel.Id = this.$attrs.id;
          this.testsTakenModel.id = this.getQuestions.id;
          this.testsTakenModel.taken_on = Date.now();
          this.testsTakenModel.score = pass;
          if (pass >= 56) {
            this.testsTakenModel.passed = true;
          }
          this.studentProgressModel.tests_taken.push(this.testsTakenModel);

          console.log(this.studentProgressModel);
          dbStore.setCollectionName("studentprogress");
          let response = await dbStore.updateItem(this.studentProgressModel);
          if (response.isStateChanged) {
            console.log("Successfully updated");
            if (pass >= 56) {
              console.log("Test Successful! with " + pass + " marks");
              this.$router.push({
                name: "testsuccess",
                params: { id: this.$attrs.id }
              });
            } else {
              this.$router.push({ name: "testsuccess", params: { id: 0 } });
            }
          } else {
            // Error in updating student progress
            console.log('Error in updating student progress!');
            console.log(response);
            this.$router.push({ name: "testsuccess", params: { id: 0 } });
          }
        }
      }
    },
    reset: function() {
      this.$refs.form.reset();
    },
    validate: function() {
      this.$refs.form.validate();
    }
  },
  computed: {
    getQuestions: function() {
      console.log(this.$attrs);
      for (var i = 0; i < this.tests.length; i++) {
        if (
          //TODO Is this the right way to get url params?
          this.tests[i].set == this.$attrs.set &&
          this.tests[i].lang == this.$attrs.lang
        ) {
          return this.tests[i] || {};
        }
      }
      return null;
    }
  }
};
</script>

<style scoped>
.question {
  width: 600px;
  padding: 30px;
  margin: 10px;
  border: 1px #dddddd solid;
  border-radius: 5px;
  background-color: white;
}
.question span {
  font-size: 20px;
}
span {
  margin: 10px;
  font-size: 25px;
}
</style>
